import {
  Typography,
  Grid,
  Link,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import {
  Button,
  ConfirmationButton,
  TextField,
} from '@roc/ui';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { useEffect } from 'react';
import { useRoutes, useStore } from '@roc/client-portal-shared/hooks';
import { getRequestIdVerificationEmailBodyContent, getRequestIdVerificationSubject } from 'libs/client-portal-shared/src/app/modules/creditBackground/requestIdVerification';
import { renderToString } from 'react-dom/server';
import { isNil } from '@roc/feature-utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    instruction: {
      fontWeight: 600,
    },
    underline: {
      fontWeight: 600,
      textDecorationLine: 'underline',
    },
  })
);

export const IdAndFinancialInformationLink = observer(({ store, lenderId }) => {

  const classes = useStyles();
  const { currentBorrower } = store;
  const { requestIdVerificationStore } = useStore();
  const { messageConfig } = requestIdVerificationStore;
  const { creditBackgroundRoutesConfig } = useRoutes();

  useEffect(() => {
    if (!isNil(currentBorrower?.borrowerId)) {
      getMessageConfig();
    }
  }, [currentBorrower?.borrowerId]);

  const getMessageConfig = async () => {
    await requestIdVerificationStore.getMessageConfig(currentBorrower?.borrowerId, lenderId);
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(messageConfig?.link);
    store.globalStore.notificationStore.showSuccessNotification({
      message: 'Link was copied to clipboard!',
    });
  };

  const subject = getRequestIdVerificationSubject();
  const bodyContent = getRequestIdVerificationEmailBodyContent(currentBorrower?.fullName, messageConfig?.link, messageConfig?.tpoName);

  const handleConfirm = () => {
    const emailBodyContent = renderToString(bodyContent);
    requestIdVerificationStore.sendRequestIdVerificationEmail(currentBorrower?.emailAddress, subject, emailBodyContent);
    store.globalStore.notificationStore.showSuccessNotification({
      message: 'Email was sent to borrower!',
    });
  }
  return (
    <>
      {messageConfig?.link &&
        <Grid item xs={12} container justifyContent="center" spacing={2}>
          <Grid
            alignItems="center"
            container
            item
            justifyContent="center"
            xs={12}
          >
            <Grid item container xs={11} spacing={2}>
              <Grid item>
                <Typography className={classes.instruction}>
                  You can click on "copy link" and send to the borrower.
                </Typography>
              </Grid>
              <Grid item container alignItems="center" spacing={2}>
                <Grid item xs={12} sm>
                  <TextField
                    testId="idVerificationLink"
                    variant="outlined"
                    value={messageConfig?.link}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleCopy}
                    testId="copyIdVerificationUrlButton"
                    fullWidth
                  >
                    COPY LINK
                  </Button>
                </Grid>
              </Grid>
              <Grid item container spacing={2}>
                <Grid item>
                  <Typography className={classes.instruction}>
                    {`You can also click "email link to borrower" and we will send the link automatically to the borrower `}<span className={classes.underline}>{store.currentBorrower?.emailAddress}</span>{`. If you want to see a preview of the email first, please navigate to`}<Link href={creditBackgroundRoutesConfig.requestIdVerification.url} target="_blank" rel="noopener noreferrer"><span> Request ID Verification.</span></Link>
                  </Typography>
                </Grid>
                <Grid item container justifyContent="center">
                  <ConfirmationButton
                    variant="contained"
                    onClick={handleConfirm}
                    color="primary"
                    testId="sendIdVerificationButton"
                    confirmDialogProps={{
                      title: 'Confirmation',
                      body: 'Email will be sent out. Please confirm',
                    }}
                  >
                    Email Link to Borrower
                  </ConfirmationButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      }
    </>
  );
});